// extracted by mini-css-extract-plugin
module.exports = {"icon":"CommentEdit_icon__tafpz","dialogButton":"CommentEdit_dialogButton__39k2_"};